(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[552],{

/***/ 6565:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(5371);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ about_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(9603);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9417);
// EXTERNAL MODULE: ./src/layouts/default/index.tsx + 7 modules
var layouts_default = __webpack_require__(6493);
// EXTERNAL MODULE: ./src/helpers/DATA.tsx + 9 modules
var DATA = __webpack_require__(8362);
;// CONCATENATED MODULE: ./public/images/about-icon1.jpg
/* harmony default export */ var about_icon1 = ({"src":"/_next/static/media/about-icon1.daeedb7d.jpg","height":96,"width":120,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAiEAABAgMJAAAAAAAAAAAAAAAAAREDEzMEBRIVFjEyQcH/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAGBEAAgMAAAAAAAAAAAAAAAAAAQIAEXH/2gAMAwEAAhEDEQA/AKGtzWzUEzMo0qpUXEz8W2bzoACuxNZCRQL2f//Z","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about-icon2.jpg
/* harmony default export */ var about_icon2 = ({"src":"/_next/static/media/about-icon2.64c6552e.jpg","height":96,"width":120,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAfEAABBAICAwAAAAAAAAAAAAABAAIDBAURBhMhQYH/xAAUAQEAAAAAAAAAAAAAAAAAAAAE/8QAGhEBAAIDAQAAAAAAAAAAAAAAAQAiAgNRBP/aAAwDAQACEQMRAD8AuK17IZXlk1KyYmV6xk6jEXB4IcNE+t68fSiIleiuQHCF0WFez//Z","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about-icon3.jpg
/* harmony default export */ var about_icon3 = ({"src":"/_next/static/media/about-icon3.a7541c00.jpg","height":96,"width":120,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAiEAABAgQHAQAAAAAAAAAAAAABAAIDERIhBAUGExQxYUH/xAAUAQEAAAAAAAAAAAAAAAAAAAAE/8QAFxEBAAMAAAAAAAAAAAAAAAAAAQADIf/aAAwDAQACEQMRAD8AqXxMyGpXRBijuc0Q2io0hl/PQJS6+zuiIn3BkDSuz//Z","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/contact-1.jpg
/* harmony default export */ var contact_1 = ({"src":"/_next/static/media/contact-1.fbc22596.jpg","height":683,"width":1024,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAABBAMBAAAAAAAAAAAAAAABAAIEEQMFMVH/xAAUAQEAAAAAAAAAAAAAAAAAAAAB/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAFB/9oADAMBAAIRAxEAPwC+3fS4WwBwkVJxMaWuJIbVmwODviIiLhf/2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/contact-2.jpg
/* harmony default export */ var contact_2 = ({"src":"/_next/static/media/contact-2.12bc3926.jpg","height":683,"width":1024,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAfEAACAQMFAQAAAAAAAAAAAAABAgADBBEFBhIhMWH/xAAVAQEBAAAAAAAAAAAAAAAAAAACA//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oADAMBAAIRAxEAPwCPQt9XdV81bVGqNblmfmQX49AH52fMexESkCv/2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/contact-3.jpg
/* harmony default export */ var contact_3 = ({"src":"/_next/static/media/contact-3.3c7657b8.jpg","height":683,"width":1024,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAABAwQDAAAAAAAAAAAAAAABAAIEAxESIQYTQf/EABQBAQAAAAAAAAAAAAAAAAAAAAL/xAAWEQEBAQAAAAAAAAAAAAAAAAABACH/2gAMAwEAAhEDEQA/AJqXyAmEaQgRs6D+1lRzcjd17jfm0REAyY3/2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/pages/about-us/index.tsx
// ** Next Imports


// ** FA Imports


// ** File Imports

// ** Data Imports

// ** Image imports






const Star5 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons/* faStar */.Tab,
                color: "#f8bd06"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons/* faStar */.Tab,
                color: "#f8bd06"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons/* faStar */.Tab,
                color: "#f8bd06"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons/* faStar */.Tab,
                color: "#f8bd06"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons/* faStar */.Tab,
                color: "#f8bd06"
            })
        ]
    });
const About = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts_default/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts_default/* SEOHead */.R, {
                title: "Internet Service Providers USA | No Credit Check Internet",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "EIN is the internet service provider in USA that has no bundles, contracts or credit checks involved. Unlimited high speed Internet for both business and homes."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "internet service providers usa, unlimited high speed internet, high speed business internet, no contract internet providers, no credit check internet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "pad-top-60 pad-bot-60 custom-border2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row equal-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-6 col-lg-6 col-sm-12 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "textual-sec1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: " No Contract, No Credit Check, No Hassle "
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-6 col-lg-6 col-sm-12 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "textual-sec2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: "col-grey1",
                                        children: "EIN brings the best networks and speed to our customers without the need for contracts or credit checks. You get a connection that is reliable, from a company that makes Internet service easy to understand."
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "pad-top-40 pad-bot-40",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4 col-lg-4 col-sm-4 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "about-box",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: about_icon1,
                                            className: "img-fluid",
                                            placeholder: "blur",
                                            alt: "About Icon"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "col-black",
                                            children: " Free WIFI Modem "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "col-grey1",
                                            children: "Every EIN installation includes a free WIFI modem to provide service across your home or business. Plus, it's yours! No need to return or pay a lease charge!"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4 col-lg-4 col-sm-4 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "about-box",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: about_icon2,
                                            className: "img-fluid",
                                            placeholder: "blur",
                                            alt: "About Icon 2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "col-black",
                                            children: " No Contract or Credit Check "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "col-grey1",
                                            children: "We never run a credit check or change pricing based on your credit history. You can cancel at any time without a penalty. Best part? No hidden fees!"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4 col-lg-4 col-sm-4 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "about-box",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: about_icon3,
                                            className: "img-fluid",
                                            placeholder: "blur",
                                            alt: "About Icon 3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "col-black",
                                            children: " Unlimited Internet "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "col-grey1",
                                            children: "We never throttle or cap your speed because of how much you've used your Internet service. This is Internet service the way it was meant to be enjoyed!"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "pad-top-40 pad-bot-60",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row custom-row1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4 col-lg-4 col-sm-4 col-12 custom-pad1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "custom-image1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: contact_1,
                                        className: "img-fluid",
                                        placeholder: "blur",
                                        alt: "Contact Image"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4 col-lg-4 col-sm-4 col-12 custom-pad1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "custom-image1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: contact_2,
                                        className: "img-fluid",
                                        placeholder: "blur",
                                        alt: "Contact Image 2"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4 col-lg-4 col-sm-4 col-12 custom-pad1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "custom-image1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: contact_3,
                                        className: "img-fluid",
                                        placeholder: "blur",
                                        alt: "Contact Image 3"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-silver2 pad-top-80 pad-bot-80",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-6 col-lg-6 col-sm-12 col-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block-element m-b-30",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "textual-sec1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "col-black m-b-10",
                                                    children: "The Nations Best Internet Service"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "m-b-20",
                                                    children: "Why Choose EIN"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    className: "line-2",
                                                    children: "."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block-element",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "list-2",
                                            children: DATA/* WHY_CHOOSE_EIN.map */.mk.map((itm, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: free_solid_svg_icons/* faCheck */.LEp
                                                        }),
                                                        " ",
                                                        itm
                                                    ]
                                                }, index))
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-6 col-lg-6 col-sm-12 col-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block-element",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "textual-sec3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "col-black",
                                                    children: " How does EIN work? "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "col-grey1",
                                                    children: "EIN uses existing service lines already at your home or business to provide the best Internet connection. All installations are completed by a Professional Technician to make sure you get a quality connection and any help you might need connecting your devices to your new network."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "col-grey1",
                                                    children: "Not only do you get a great Internet connection, but you also get support from our fantastic dedicated Support Team. You can connect with us through Facebook Messenger, text, phone, and live chat!"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "block-element m-b-20",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "progress-title",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                    children: [
                                                        "Customer Satisfaction ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: "96%"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "progress progress-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "progress-bar progress-bar-striped progress-bar-animated",
                                                    role: "progressbar",
                                                    style: {
                                                        width: "96%"
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "block-element",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "progress-title2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Star5, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: " 4.8/5 "
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            href: "https://www.facebook.com/easyinternetnow/reviews",
                                                            children: "Facebook Reviews"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "progress-title",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                    children: [
                                                        "Network Up-Time ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: " 99% "
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "progress progress-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "progress-bar progress-bar-striped progress-bar-animated",
                                                    role: "progressbar",
                                                    style: {
                                                        width: "99%"
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "pad-top-60 pad-bot-60",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-6 col-lg-6 col-sm-12 col-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block-element m-b-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "textual-sec3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "col-black",
                                                    children: " Want to learn more? "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "col-grey1",
                                                    children: "Watch this video to see how EIN operates, and how we bring you the best speeds and service!"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block-element",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "video-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                width: "560",
                                                height: "315",
                                                src: "https://www.youtube.com/embed/NGVlLyO9m1Y",
                                                title: "YouTube video player",
                                                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                                allowFullScreen: true
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-6 col-lg-6 col-sm-12 col-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block-element m-b-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "textual-sec3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "col-grey1",
                                                children: "Affordable price and no contract is the best part. If my internet is not working properly, the issue is always resolved the same day; even though there are rare instances. Great company, I recommend their service."
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "block-element",
                                        children: [
                                            DATA/* REVIEWS.map */.th.map((review, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "review-box",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "review-title",
                                                            children: [
                                                                review.img,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                    children: review.name
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                    children: review.from
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Star5, {})
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "review-desc",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: review.review
                                                            })
                                                        })
                                                    ]
                                                }, index)),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "block-element",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "progress-title2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Star5, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                    children: " 4.8/5 "
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    target: "_blank",
                                                                    href: "https://www.facebook.com/easyinternetnow/reviews",
                                                                    rel: "noopener noreferrer",
                                                                    children: "Facebook Reviews"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "progress-title2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Star5, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                    children: " 5/5 "
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    target: "_blank",
                                                                    href: "https://g.page/EIN_Internet?gm",
                                                                    rel: "noopener noreferrer",
                                                                    children: "Google Reviews"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
/* harmony default export */ var about_us = (About);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,948,910,493,774,888,179], function() { return __webpack_exec__(6565); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);